import { render, staticRenderFns } from "./TimeoffSettings.vue?vue&type=template&id=674d1c6b"
import script from "./TimeoffSettings.vue?vue&type=script&lang=js"
export * from "./TimeoffSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports